var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-admin-reports-main__table-cell page-admin-reports-main__table-cell-comment",class:{
    'page-admin-reports-main__table-cell-comment_clickable': _vm.isCommentShortened,
  },on:{"click":function($event){_vm.isCommentShortened ? _vm.showComment() : null}}},[_vm._v(" "+_vm._s(_vm.shortComment)+_vm._s(_vm.isCommentShortened ? '...' : '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }